
import React, { ReactElement } from 'react';
import Styles from './HeaderTitle.module.scss'

interface HeaderTitleProps {
  title: string,
  image: ReactElement
}

const HeaderTitle: React.FC<HeaderTitleProps> = (props: HeaderTitleProps) => {
  return (
    <div className="row mb-3 text-left">
        <div className="col-lg-auto col-md-auto col-sm-6 col-xs-12">
            {props.image}
        </div>
        <div className="col-lg-10 col-md-10 col-sm-10 col-xs-12">
            <h5 className={Styles.color}>
              {props.title}
            </h5>
        </div>
    </div>
  );
};

export default HeaderTitle;
